// src/pages/LoginPage.tsx
import React, { useRef, useState } from "react";
import { Box, Container, Paper, CircularProgress } from "@mui/material";
// import logo from "Assets/svgs/logo.svg"; // replace path as needed
import logo from "Assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { useBoundStore } from "Zustand/store/mainStore";
import { Button, TextField, Typography } from "Atoms";
import PasswordField from "Atoms/PasswordField";
import { loginRequest } from "authConfig";

const LoginPage = ({ instance }) => {
  const navigate = useNavigate();

  const { login, auth, testvisionusername, setTestvisionUsername } =
    useBoundStore();

  // Email/password login is temporarily disabled on the UI (Daniel, 2026-10-15)
  // — SSO + TestVision User Name is the only login path for now.
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const [ssoLoading, setSsoLoading] = useState(false);
  const [ssoError, setSsoError] = useState("");
  const testvisionInputRef = useRef<HTMLInputElement>(null);

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   const isLoggedIn = await login(email, password);
  //   if (isLoggedIn) {
  //     navigate("/projects");
  //   }
  // };

  const handleLogin = async () => {
    if (!testvisionusername.trim()) {
      setSsoError("TestVision User Name is required for SSO login.");
      testvisionInputRef.current?.focus();
      return;
    }

    setSsoError("");
    setSsoLoading(true);
    try {
      //if (!process.env.REACT_APP_MSAL_CLIENT_ID) {
      //  alert(
      //    "Missing REACT_APP_MSAL_CLIENT_ID. Add the Entra Application/client ID GUID before testing SSO."
      //  );
      //  setSsoLoading(false);
      //  return;
      //}

      // loginRedirect navigates away from the page. The result is handled after Entra redirects back.
      await instance.loginRedirect(loginRequest);
    } catch (error: any) {
      setSsoLoading(false);
      alert(`Login failed. Please try again. ${error.message}`);
    }
  };

  return (
    <Container
      maxWidth="xs"
      sx={{
        height: "100vh", display: "flex", alignItems: "center",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          width: "100%",
        }}
      >
        <Box textAlign="center" mb={3}>
          <img
            src={logo}
            alt="Logo"
            style={{ width: "auto", height: "70px", marginBottom: 16 }}
          />
        </Box>

        <Box component="form" onSubmit={(e) => e.preventDefault()}>
          {/* Email/password login is temporarily disabled on the UI
              (Daniel, 2026-10-15) — SSO + TestVision User Name only.
          <TextField
            label="Email"
            type="email"
            fullWidth
            required
            margin="normal"
            autoComplete=""
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <PasswordField
            label="Password"
            name="password"
            required
            sx={{ marginTop: 1, marginBottom: 1 }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autocomplete="current-password"
          />
          */}

          <TextField
            label="TestVision User Name"
            fullWidth
            required
            margin="normal"
            autoComplete="username"
            inputRef={testvisionInputRef}
            value={testvisionusername}
            onChange={(e) => {
              setTestvisionUsername(e.target.value);
              if (ssoError) setSsoError("");
            }}
          />

          {/* Login button disabled alongside email/password fields above.
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 1 }}
            disabled={auth.loading}
          >
            {auth.loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Login"
            )}
          </Button>
          */}

          <Button
            //type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 1 }}
            disabled={auth.loading || ssoLoading}
            onClick={handleLogin}
          >
            {ssoLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "SSO Login"
            )}
          </Button>

          {(auth.error || ssoError) && (
            <Typography color="error" variant="body2" mt={2}>
              {auth.error || ssoError}
            </Typography>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default LoginPage;